import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const GridStatementBlock = (props) => {
    if (!props.text) { return null; }

    return (
        <div className='col-span-3 sm:col-span-5 md:col-span-7 lg:col-span-9 bg-foreground px-20 pt-20 pb-60 sm:px-40 sm:pt-40 sm:pb-120 lg:px-60 lg:pt-60 mr-1 mb-1'>
            <blockquote
                className='type-style-1 max-w-[20em]'
                dangerouslySetInnerHTML={{ __html: props.text }} />
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    text: PropTypes.string.isRequired
};

GridStatementBlock.propTypes = propTypes;

export default GridStatementBlock;
